/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import classes from "./activate.module.css";
import Loader from "../../../component/loader";
import { connect } from "react-redux";
import actionTypes from "../../../store/actions";
import BusApiCall from "../../../helper/axios";
import constants from "../../../helper/constants";
import { withTranslation } from "react-i18next";
import Breadcrumb from "../../../component/breadcrumb";
import Grid from "@mui/material/Grid";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ActivationTable from "./activationTable";
import Button from "../../../component/button";
import Avatar from "@mui/material/Avatar";
import { withNavigation } from "../../../helper/withNavigation";
import {formatDate} from "../../../helper/dateFormatter";

// Activations page class
class Activation extends Component {
  // Declare property values that belongs to the component
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      bread: [],
      customerDetails: {},
      orderId: "",
      activationData: {},
      tabs: [],
      renderView: false,
      showForm: true,
      components: [],
      disableActivationButton: true,
      totalActivationCount: 0,
      associationType: [],
      responseBucketsData: [],
      activeTab: 0,
    };
  }

  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    this.props.setCompDidMount();

    let search = new URLSearchParams(this.props.router.location.search);
    let tenantId = search.get("tenantId");
    let orderIdUrlParam = this.props.router.params.id;
    let bread = [
      { title: this.props.t("ORDERS"), url: "/orders" },
      {
        title: orderIdUrlParam,
        url: tenantId
          ? `/order/${orderIdUrlParam}?tenantId=${tenantId}`
          : `/order/${orderIdUrlParam}`,
      },
      {
        title: this.props.t("ACTIVATE"),
        url: this.props.router.location.pathname,
      },
    ];

    this.setState({ bread, loading: true });
    let data = {
      tenantId: tenantId,
    };

    BusApiCall(
      "GET",
      `${constants.busV4Url}/orders/${this.props.router.params.id}/components`,
      data,
    )
      .then((res) => {
        // let res = {};
        // res.data = tempData;
        this.setState({
          bread,
          customerDetails: res.data.customerDetails,
          orderId: this.props.router.params.id,
          activationData: res.data,
          responseBucketsData: res.data.buckets,
        });
        let tabs = [];
        for (var i = 0; i < res.data.buckets.length; i++) {
          for (var j = 0; j < res.data.buckets[i].components.length; j++) {
            for (
              var k = 0;
              k < res.data.buckets[i].components[j].activationParams.length;
              k++
            ) {
              res.data.buckets[i].components[j].activationParams[k].edit =
                false;
              let tempParamaters =
                res.data.buckets[i].components[j].activationParams[k]
                  .parameters;
              if (tempParamaters.slice(-2) === ",]") {
                tempParamaters =
                  tempParamaters.substring(0, tempParamaters.length - 2) + "]";
              }
              let parameters = JSON.parse(tempParamaters);
              for (var p = 0; p < parameters.length; p++) {
                parameters[p].value = parameters[p].value
                  ? parameters[p].value
                  : "";
                parameters[p].isInvalid = false;
              }
              res.data.buckets[i].components[j].activationParams[k].parameters =
                parameters;
            }
          }
          tabs.push(res.data.buckets[i].componentType);
          this.state.components.push(res.data.buckets[i].componentType.id);
        }

        this.setState({
          associationType: tabs,
          loading: false,
          renderView: true,
        });
      })
      .catch((err) => {
        // Error handling
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  }

  handleTabChange = (event, newValue) => {
    this.setState({
      activeTab: newValue,
    });
  };

  hasTabValue = (val) => {
    for (var i = 0; i < this.state.tabs.length; i++) {
      if (this.state.tabs[i] === val) {
        return true;
      }
    }
  };

  changeData = (type, productIndex, rowIndex, e, inputType) => {
    let items = this.getComponentsFromResponseData(type);
    let product = items[productIndex];
    let rowData = product.activationParams[rowIndex];
    let value = e.target.value === " " ? "" : e.target.value;
    for (var i = 0; i < rowData.parameters.length; i++) {
      if (rowData.parameters[i].name === e.target.name) {
        if (rowData.parameters[i].type === "boolean") {
          if (rowData.parameters[i].value) {
            rowData.parameters[i].value = false;
          } else {
            rowData.parameters[i].value = true;
          }
        } else {
          rowData.parameters[i].value = value;
        }
        if (value === "") {
          rowData.parameters[i].isInvalid = false;
        }
      }
    }
    rowData.updated = true;
    product.activationParams[rowIndex] = rowData;
    items[productIndex] = product;
    this.setState({
      showForm: !this.state.showForm,
      [type]: items,
      disableActivationButton: false,
    });
  };

  getComponentsFromResponseData = (type) => {
    for (var m = 0; m < this.state.responseBucketsData.length; m++) {
      if (this.state.responseBucketsData[m].componentType.id === type) {
        return this.state.responseBucketsData[m].components;
      }
    }
  };

  validateInput = (type, productIndex, rowIndex, e) => {
    let items = this.state[type];
    let product = items[productIndex];
    let rowData = product.activationParams[rowIndex];
    if (e.target.value !== "") {
      for (var i = 0; i < rowData.parameters.length; i++) {
        if (rowData.parameters[i].name === e.target.name) {
          let reg = rowData.parameters[i].validation;
          if (reg) {
            if (reg.charAt(0) === "/") {
              reg = reg.slice(1);
            }
            if (reg.charAt(reg.length - 1) === "/") {
              reg = reg.slice(0, -1);
            }
          }
          if (new RegExp(reg).test(e.target.value)) {
            rowData.parameters[i].isInvalid = false;
          } else {
            rowData.parameters[i].isInvalid = true;
          }
        }
      }
      // }
    }

    product.activationParams[rowIndex] = rowData;
    items[productIndex] = product;
    this.setState({
      showForm: !this.state.showForm,
      [type]: items,
    });
  };

  editRow = (type, productIndex, rowIndex) => {
    let items = this.getComponentsFromResponseData(type);
    let product = items[productIndex];
    let rowData = product.activationParams[rowIndex];
    rowData.edit = !rowData.edit;
    product.activationParams[rowIndex] = rowData;
    items[productIndex] = product;
    this.setState({
      showForm: !this.state.showForm,
      [type]: items,
    });
  };

  getBucketName = (type) => {
    for (var m = 0; m < this.state.responseBucketsData.length; m++) {
      if (this.state.responseBucketsData[m].componentType.id === type) {
        return this.state.responseBucketsData[m].componentType.displayNamePlural
          ? this.state.responseBucketsData[m].componentType.displayNamePlural
          : this.state.responseBucketsData[m].componentType.name;
      }
    }
  };

  validateActivationData = () => {
    let components = this.state.components;
    for (var c = 0; c < components.length; c++) {
      let items = this.getComponentsFromResponseData(components[c]);
      for (var i = 0; i < items.length; i++) {
        for (var j = 0; j < items[i].activationParams.length; j++) {
          if (
            items[i].activationParams[j].updated &&
            !items[i].activationParams[j].edit
          ) {
            for (
              var p = 0;
              p < items[i].activationParams[j].parameters.length;
              p++
            ) {
              if (
                items[i].activationParams[j].parameters.every((a) => a.value)
              ) {
                if (items[i].activationParams[j].parameters[p].isInvalid) {
                  this.setState({ loading: false });
                  let invalidData = {
                    component: this.getBucketName(components[c]),
                    product: items[i].productName,
                    row: j + 1,
                  };
                  this.props.setErrorMessage(
                    this.props.t("INVALID_ACTIVATION_DATA", { invalidData }),
                    false,
                  );
                  // this.props.setErrorMessage(`Invalid data entered in "${this.getBucketName(components[c])}" under product "${items[i].productName}" on row ${j + 1}.`, false);
                  return false;
                }
              } else {
                items[i].activationParams[j].updated = false;
              }
            }
          }
        }
      }
    }
    return true;
  };

  activate = () => {
    this.setState({
      loading: true,
      disableActivationButton: true,
    });
    let payload = {};

    let search = new URLSearchParams(this.props.router.location.search);
    let tenantId = search.get("tenantId");

    if (tenantId) {
      payload.tenantId = tenantId;
    }

    payload.orderId = this.state.activationData.orderId;
    payload.activationData = [];

    let updatePayload = {};
    updatePayload.orderId = this.state.activationData.orderId;
    updatePayload = [];

    let components = this.state.components;

    if (this.validateActivationData()) {
      for (let c = 0; c < components.length; c++) {
        let items = this.getComponentsFromResponseData(components[c]);
        for (let i = 0; i < items.length; i++) {
          for (let j = 0; j < items[i].activationParams.length; j++) {
            if (
              items[i].activationParams[j].updated &&
              !items[i].activationParams[j].edit
            ) {
              let device = {};
              device.productId = items[i].productId;
              device.activationId = items[i].activationParams[j].activationId;
              device.param = [];
              let data = items[i].activationParams[j].parameters;
              for (let k = 0; k < data.length; k++) {
                // if (data[k].value.trim() === '') {
                //     payload.activationData = [];
                //     updatePayload.activationData = [];
                //     this.props.setErrorMessage(`Empty "${data[k].name}" found in "${components[c]}" under product name "${items[i].productName}" at row ${j + 1}`, false)
                //     this.setState({
                //         loading: false
                //     })
                //     return;
                // }
                device.param.push({
                  name: data[k].name,
                  value: data[k].value,
                });
              }
              if (items[i].activationParams[j].status !== "AVAILABLE") {
                if (!items[i].activationParams[j].edit) {
                  device.activationId =
                    items[i].activationParams[j].activationId;
                  device.status = items[i].activationParams[j].status;
                  device.productId = items[i].productId;
                  updatePayload.push(device);
                }
              } else {
                payload.activationData.push(device);
              }
            }
          }
        }
      }
      if (payload.activationData.length + updatePayload.length > 0) {
        this.setState({
          totalActivationCount:
            payload.activationData.length + updatePayload.length,
        });
        for (let c = 0; c < components.length; c++) {
          let items = this.getComponentsFromResponseData(components[c]);
          for (let i = 0; i < items.length; i++) {
            for (let j = 0; j < items[i].activationParams.length; j++) {
              if (
                items[i].activationParams[j].updated &&
                !items[i].activationParams[j].edit
              ) {
                let componentData = [...items];
                let procudtObject = items[i];
                let paramsObject = procudtObject.activationParams[j];
                paramsObject.status = "PROCESSING";
                paramsObject.displayStatus = "Activation In Processing";
                paramsObject.updated = false;
                procudtObject.activationParams[j] = paramsObject;
                componentData[i] = procudtObject;
                let allComponentsData = [...this.state.responseBucketsData];
                for (let k = 0; k < allComponentsData.length; k++) {
                  let tempComponents = allComponentsData[k].components;
                  for (let l = 0; l < tempComponents.length; l++) {
                    if (
                      allComponentsData[k].components[l].productId ===
                      componentData[i].productId
                    ) {
                      allComponentsData[k].components[l].activationParams =
                        componentData[i].activationParams;
                    }
                  }
                }
                this.setState(
                  {
                    responseBucketsData: allComponentsData,
                    renderView: false,
                  },
                  () => {
                    this.setState({
                      renderView: true,
                    });
                  },
                );
              }
            }
          }
        }
      } else {
        this.props.setErrorMessage(
          this.props.t("NO_ITEMS_FOUND_FOR_ACTIVATION"),
          false,
        );
        this.setState({
          loading: false,
          disableActivationButton: false,
        });
      }

      let count = 0;
      if (payload.activationData.length > 0) {
        count++;
        BusApiCall(
          "POST",
          `${constants.busV4Url}/orders/${this.state.activationData.orderId}/activations`,
          payload,
        )
          .then((res) => {
            if (
              count ===
              updatePayload.length + (payload.activationData.length > 0 ? 1 : 0)
            ) {
              this.showActivationMessage();
            }
          })
          .catch((e) => {
            if (
              count ===
              updatePayload.length + (payload.activationData.length > 0 ? 1 : 0)
            ) {
              this.showActivationMessage();
            }
          });
      }
      if (updatePayload.length > 0) {
        for (var i = 0; i < updatePayload.length; i++) {
          count++;
          let data = {};
          data.orderId = this.state.activationData.orderId;
          if (tenantId) {
            data.tenantId = tenantId;
          }
          data.activationData = [];
          let paramData = {};
          paramData.productId = updatePayload[i].productId;
          paramData.activationId = updatePayload[i].activationId;
          paramData.status = updatePayload[i].status;
          paramData.param = updatePayload[i].param;
          data.activationData.push(paramData);
          BusApiCall(
            "PUT",
            `${constants.busV4Url}/orders/${this.state.activationData.orderId}/activations/${updatePayload[i].activationId}`,
            data,
          )
            .then((res) => {})
            .catch((e) => {});
          if (
            count ===
            updatePayload.length + (payload.activationData.length > 0 ? 1 : 0)
          ) {
            this.showActivationMessage();
          }
        }
      }
    }
  };

  showActivationMessage = () => {
    this.props.setErrorMessage(
      this.props.t("ACTIVATION_INITIATED_SUCCESSFULLY"),
      true,
    );
    this.setState({
      loading: false,
    });
  };

  reloadActivationData = () => {
    this.setState({
      loading: true,
    });
    let search = new URLSearchParams(this.props.router.location.search);
    let tenantId = search.get("tenantId");

    let data = {
      tenantId: tenantId,
    };
    BusApiCall(
      "GET",
      `${constants.busV4Url}/orders/${this.props.router.params.id}/components`,
      data,
    )
      .then((res) => {
        this.setState({
          activationData: res.data,
        });
        for (let i = 0; i < res.data.buckets.length; i++) {
          let oldBucketData = this.getComponentsFromResponseData(
            res.data.buckets[i].componentType.id,
          );
          let oldBucketName = res.data.buckets[i].componentType
            .displayNamePlural
            ? res.data.buckets[i].componentType.displayNamePlural
            : res.data.buckets[i].componentType.name;

          for (let j = 0; j < res.data.buckets[i].components.length; j++) {
            for (
              let k = 0;
              k < res.data.buckets[i].components[j].activationParams.length;
              k++
            ) {
              if (
                res.data.buckets[i].components[j].activationParams[k].status !==
                "AVAILABLE"
              ) {
                // console.log("object activated")
                // console.log('oldBucketData', oldBucketData);
                let productIndex = oldBucketData.findIndex(
                  (a) =>
                    a.productId === res.data.buckets[i].components[j].productId,
                );
                let procudtObject = oldBucketData[productIndex];
                // console.log('productIndex', productIndex, procudtObject);

                let paramsIndex = procudtObject.activationParams.findIndex(
                  (a) =>
                    a.activationId ===
                    res.data.buckets[i].components[j].activationParams[k]
                      .activationId,
                );
                let paramsObject = procudtObject.activationParams[paramsIndex];
                // console.log('paramsIndex', paramsIndex, paramsObject);

                if (
                  paramsObject.status === "PROCESSING" ||
                  paramsObject.status === "PENDING"
                ) {
                  // console.log("object is in process")
                  let success = true;
                  let tempParamaters =
                    res.data.buckets[i].components[j].activationParams[k]
                      .parameters;
                  if (tempParamaters.slice(-2) === ",]") {
                    tempParamaters =
                      tempParamaters.substring(0, tempParamaters.length - 2) +
                      "]";
                  }
                  let newParams = JSON.parse(tempParamaters);
                  for (var p = 0; p < paramsObject.parameters.length; p++) {
                    for (var q = 0; q < newParams.length; q++) {
                      // console.log('old object name', paramsObject.parameters[p].name, paramsObject.parameters[p].value);
                      // console.log('new object name', newParams[q].name, newParams[q].value)
                      if (
                        paramsObject.parameters[p].name === newParams[q].name
                      ) {
                        // console.log('match found');
                        if (success) {
                          if (
                            paramsObject.parameters[p].value ===
                            newParams[q].value
                          ) {
                            // console.log('success true');
                            success = true;
                          } else {
                            // console.log('success false');
                            success = false;
                            break;
                          }
                        }
                      }
                    }
                  }
                  if (success) {
                    paramsObject.status =
                      res.data.buckets[i].components[j].activationParams[
                        k
                      ].status;
                    paramsObject.displayStatus =
                      res.data.buckets[i].components[j].activationParams[
                        k
                      ].displayStatus;
                    let metadata = res.data.buckets[i].components[j]
                      .activationParams[k].metadata
                      ? res.data.buckets[i].components[j].activationParams[k]
                          .metadata
                      : [];
                    paramsObject.metadata = metadata;
                    // console.log('final set data');
                    procudtObject.activationParams[paramsIndex] = paramsObject;
                    oldBucketData[productIndex] = procudtObject;

                    let count = this.state.totalActivationCount;
                    count--;
                    let finalData = [...this.state.responseBucketsData];
                    for (let m = 0; m < finalData.length; m++) {
                      if (
                        finalData[m].componentType.id ===
                        res.data.buckets[i].componentType.id
                      ) {
                        finalData[m].components = oldBucketData;
                      }
                    }
                    this.setState({
                      [oldBucketName]: oldBucketData,
                      responseBucketsData: finalData,
                      showForm: !this.state.showForm,
                      disableActivationButton: count === 0 ? false : true,
                    });
                  }
                }
              }
            }
          }
        }
        this.setState({
          loading: false,
        });
      })
      .catch((err) => {
        // Error handling
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };

  downloadCredentials = (id, data) => {
    let josnFile =
      "text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(data));

    var link = document.createElement("a");
    link.href = "data:" + josnFile;
    link.download = id + ".json";
    this.setState({
      loading: false,
    });
    link.dispatchEvent(new MouseEvent("click"));
  };

  // Render Activation view
  render() {
    const { t } = this.props;
    return (
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <Breadcrumb list={this.state.bread} />
              </Grid>
            </Grid>
          </div>
        </div>
        <main style={{ position: "relative" }}>
          {/* <p>Use the following form to activate multiple subscriptions.</p> */}
          {/* <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <Card>
                            <CardContent>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>{t('CUSTOMER_NAME')}</TableCell>
                                            <TableCell>{this.state.customerDetails.customerName}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>{t('CUSTOMER_BAN')}</TableCell>
                                            <TableCell>{this.state.customerDetails.customerBan}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>{t('Order ID')}</TableCell>
                                            <TableCell>{this.state.orderId}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid> */}
          {/* <Grid container spacing={2}>
                    <Grid item xs={5}>
                        <Input
                            size={'small'}
                            variant={'outlined'}
                            name='customerName'
                            label='Customer Name'
                            value={this.state.customerDetails.customerName}
                            disabled={true}
                            inputClass={classes.inputBottomMargin}
                        />
                    </Grid>
                    <Grid item xs={7}></Grid>

                    <Grid item xs={5}>
                        <Input
                            size={'small'}
                            variant={'outlined'}
                            name='orderId'
                            label='Order ID'
                            value={this.state.orderId}
                            disabled={true}
                            inputClass={classes.inputBottomMargin}

                        />
                    </Grid>
                    <Grid item xs={7}></Grid>

                    <Grid item xs={5}>
                        <Input
                            size={'small'}
                            variant={'outlined'}
                            name='customerBan'
                            label='Customer BAN'
                            value={this.state.customerDetails.customerBan}
                            disabled={true}
                            inputClass={classes.inputBottomMargin}

                        />
                    </Grid>
                    <Grid item xs={7}></Grid>
                </Grid> */}
          {this.state.renderView && (
            <Grid container spacing={2} style={{ marginTop: 20 }}>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <Tabs
                  // textColor="primary"
                  variant="scrollable"
                  scrollButtons="auto"
                  indicatorColor="primary"
                  className={classes.activationTabs}
                  value={this.state.activeTab}
                  onChange={this.handleTabChange}
                >
                  {(this.state.associationType &&
                    this.state.associationType.length) > 0
                    ? this.state.associationType.map((row, index) => (
                        <Tab
                          key={index}
                          label={row.name}
                          icon={
                            <Avatar
                              alt={row.name}
                              src={constants.imageUrl + row.iconName}
                            ></Avatar>
                          }
                        />
                      ))
                    : null}
                </Tabs>
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                {this.state.components.map((comp, i) => (
                  <React.Fragment key={i}>
                    {this.state.activeTab === i && (
                      <ActivationTable
                        data={this.state.responseBucketsData[i].components}
                        componentType={comp}
                        showForm={this.state.showForm}
                        onChange={this.changeData}
                        validateInput={this.validateInput}
                        editRow={this.editRow}
                        reloadActivationData={this.reloadActivationData}
                        downloadCredentials={this.downloadCredentials}
                        isEdittable={this.props.userPerms.includes(
                          "CUMULATOR-ACTIVATION_ADMIN",
                        )}
                      />
                    )}
                  </React.Fragment>
                ))}
              </Grid>
              <Grid
                item
                align="right"
                size={{
                  xs: 12,
                }}
              >
                {this.props.userPerms.includes(
                  "CUMULATOR-ACTIVATION_ADMIN",
                ) && (
                  <Button
                    className={classes.activateButton}
                    disabled={this.state.disableActivationButton}
                    onClick={() => {
                      this.activate();
                    }}
                  >
                    {t("ACTIVATE")}
                  </Button>
                )}
                <Button
                  className={classes.activateButton}
                  onClick={() => {
                    this.props.router.navigate("/orders");
                  }}
                >
                  {t("BACK")}
                </Button>
              </Grid>
            </Grid>
          )}
          <Loader loading={this.state.loading} />
        </main>
      </div>
    );
  }
}

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
  };
};

const mapStateToProps = (state) => {
  console.log("Garima", state);
  return {
    userPerms: state.auth.userPerms,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(withNavigation(Activation)));
